/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import request from '@/utils/request'
import { APICore } from '@/utils/servicesApi'
const qs = require('qs')

export function deleteAgentRolesOneStored(data) {
  return requestRaw({
    url: APICore() + '/agent/delete-roles-one',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function updateAgentRolesOneStored(data) {
  return requestRaw({
    url: APICore() + '/agent/update-roles-one',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function getAgentRel(data) {
  return requestRaw({
    url: APICore() + '/agent/get-agent-rel',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function updatePasswordStored(data) {
  return requestRaw({
    url: APICore() + '/agent/update-agent-password',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function updateStored(data) {
  return requestRaw({
    url: APICore() + '/agent/update',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function getAgentById(id) {
  return requestRaw({
    url: APICore() + '/agent/get-agent-by-id?id=' + id,
    method: 'GET',
    // data: data // untuk array data post
  })
}
export function getAgentList(data) {
  return requestRaw({
    url: APICore() + '/agent/list',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function createStored(data) {
  return requestRaw({
    url: APICore() + '/agent/create',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function connectToAgentOwner(dataArr) {
  return request({
    url: APICore() + '/omni/connect-to-agent-owner?license_id=' + dataArr.license_id + "&agent_id=" + dataArr.agent_id,
    method: 'GET',
    // data: data // untuk array data post
  })
}
export function getRoomList(data) {
  return request({
    url: APICore() + '/omni/room-list',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}
export function getHotChatList(data) {
  return request({
    url: APICore() + '/omni/hot-chat-list',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function getColdChatList(data) {
  return request({
    url: APICore() + '/omni/cold-chat-list',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}


// WEBPACK FOOTER //
// ./src/api/agent.js